/**
 * Hook for the global /risks page. The home-widget uses `useTopRisks`
 * (separate cache key since its result is severity-ranked + trimmed),
 * and the project-detail tab uses `useProjectRisks`.
 */
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "@/api/client";
import { listRisks, type RiskIndicator } from "@/api/risks";

export const RISKS_KEY = ["risks", "all"] as const;

export function useRisks(includeResolved = false) {
  return useQuery<RiskIndicator[], Error>({
    queryKey: [...RISKS_KEY, { includeResolved }] as const,
    queryFn: () => listRisks({ includeResolved }),
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 401) return false;
      return failureCount < 1;
    },
    staleTime: 30_000,
  });
}
